<i18n src="./../../i18n/main_footer.json"></i18n>

<template>
    <div>
        <div class="container mt-footer-section">
            <div class="row justify-content-start">
                <div class="col-md-2 pt-md-0 pl-0">
                    <h6 class="mb-4" v-text="$t('contact')"/>
                    <p class="footer-item" v-text="contactPhone"/>
                    <p class="footer-item" v-text="contactEmail"/>
                    <a href="https://www.facebook.com/mToilet-326809284638472/" class="icon-link facebook brand"><font-awesome-icon class="fa" :icon="{ prefix: 'fab', iconName: 'facebook-f' }" /></a>
                </div>
                <div class="col-md-2 pt-3 pt-md-0 pl-0">
                    <h6 class="mb-4" v-text="$t('offer.title')"/>
                    <router-link :to="{name: 'offerCategory', params: {category: categoryToilets}}"><p class="footer-item" v-text="$t('offer.toilets')"/></router-link>
                    <router-link :to="{name: 'offerCategory', params: {category: categoryContainers}}"><p class="footer-item" v-text="$t('offer.containers')"/></router-link>
                    <router-link :to="{name: 'offerCategory', params: {category: categoryFences}}"><p class="footer-item" v-text="$t('offer.fancies')"/></router-link>
                    <router-link :to="{name: 'offerCategory', params: {category: categoryOthers}}"><p class="footer-item" v-text="$t('offer.others')"/></router-link>
                    <router-link :to="{name: 'service'}"><p class="footer-item" v-text="$t('offer.service')"/></router-link>
                </div>
                <div class="col-md-3 pt-4 pt-lg-0 pl-0">
                    <h6 class="mb-4" v-text="$t('information.title')"/>
                    <router-link :to="{name: 'regulation'}"><p class="footer-item" v-text="$t('information.statute')"/></router-link>
                    <router-link :to="{name: 'departments'}"><p class="footer-item" v-text="$t('information.departments')"/></router-link>
                    <a :href="$t('information.owuUrl')"><p class="footer-item" v-text="$t('information.owu')"/></a>
                    <a :href="$t('information.priceListsUrl')"><p class="footer-item" v-text="$t('information.priceLists')"/></a>
                </div>
            </div>
            <div class="row justify-content-start">
                <div class="row-6 pt-2 mb-5 pl-3">
                    <p class="small mb-0 c-white" v-text="$t('copyright')"/>
                    <p class="small mb-0 c-white">{{ $t('cookieInfo.info') }} <router-link :to="{name: 'privacyPolicy'}" class="c-blue" rel="nofollow" v-text="$t('cookieInfo.cookiePolices')"/>.</p>
                </div>
            </div>
        </div>

        <div v-if="Const.PRIMARY_LOCALE === 'pl'" class="mt-to-md-only">
            <router-link :to="{name: 'buyOnline'}"><img class="lazy mt-phone-fixed" src="/assets/mt-order-btn.png"></router-link>
            <a :href="'tel:' + contactPhone"><img class="lazy mt-phone-fixed" src="/assets/mt-phone-btn.png"></a>
        </div>
        <cookie-law theme="base">
            <div slot-scope="props" class="row">
                <div class="cookie-message col-lg-10" v-html="$t('cookieInfo.popup')" />
                <div class="col-lg-2">
                    <button class="btn btn-primary btn-lg mt-button mt-button-primary cookie-button" @click="acceptAllCookies(props)" v-text="$t('cookieInfo.acceptButton')" />
                    <button class="btn btn-primary btn-lg mt-button mt-button-primary cookie-button mt-2" @click="declineCookies(props)" :class="locale" v-text="$t('cookieInfo.declineButton')" />
                    <button class="btn btn-primary btn-lg mt-button mt-button-primary cookie-button mt-2" @click="openCookieModal(props)" :class="locale" v-text="$t('cookieInfo.editButton')" />
                </div>
            </div>
        </cookie-law>
        <div class="modal fade text-center" id="cookieModal" tabindex="-1" role="dialog" aria-labelledby="modalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" v-text="$t('cookieInfo.modal.title')" />
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body text-justify">
                            <p v-text="$t('cookieInfo.modal.message')" />
                            <p class="ml-2 mt-2 font-weight-bold" v-text="$t('cookieInfo.modal.header')" />
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" disabled checked id="requiredCookieSwitch">
                                <label class="custom-control-label mt-c-blue-regular" for="requiredCookieSwitch" v-text="$t('cookieInfo.modal.requiredCookieSwitchName')" />
                                <p class="mt-fs-small" v-text="$t('cookieInfo.modal.requiredCookieSwitchDescription')" />
                            </div>
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" checked id="marketingCookieSwitch" v-model="marketingCookieAllow">
                                <label class="custom-control-label mt-c-blue-regular" for="marketingCookieSwitch" v-text="$t('cookieInfo.modal.marketingCookieSwitchName')" />
                                <p class="mt-fs-small" v-text="$t('cookieInfo.modal.marketingCookieSwitchDescription')" />
                            </div>
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" checked id="analyticsCookieSwitch" v-model="analyticsCookieAllow">
                                <label class="custom-control-label mt-c-blue-regular" for="analyticsCookieSwitch" v-text="$t('cookieInfo.modal.analyticsCookieSwitchName')" />
                                <p class="mt-fs-small" v-text="$t('cookieInfo.modal.analyticsCookieSwitchDescription')" />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary btn-lg mt-button mt-button-primary save-button" v-on:click="saveSelectedCookies" v-text="$t('cookieInfo.modal.save')" />
                            <button type="button" class="btn btn-secondary mt-button mt-button-secondary" data-dismiss="modal" v-on:click="reloadPage" v-text="$t('cookieInfo.modal.close')" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CookieLaw from 'vue-cookie-law'
    import $ from "jquery";
    import {Const} from "@/main";

    export default {
        name: "MainFooter",
        components: { CookieLaw },
        data () {
            return {
                locale: this.$i18n.locale,
                contactPhone: Const.CONTACT_PHONE,
                contactEmail: Const.CONTACT_EMAIL,
                categoryToilets: Const.CATEGORY_TOILETS,
                categoryContainers: Const.CATEGORY_CONTAINERS,
                categoryFences: Const.CATEGORY_FANCIES,
                categoryOthers: Const.CATEGORY_OTHERS,
                cookieProps: null,
                marketingCookieAllow: true,
                analyticsCookieAllow: true
            }
        },
        mounted () {

        },
        methods: {
            acceptAllCookies(props) {
                this.marketingCookieAllow = true
                this.analyticsCookieAllow = true
                this.$store.dispatch('saveMarketingConsentState', this.marketingCookieAllow)
                this.$store.dispatch('saveAnalyticsConsentState', this.analyticsCookieAllow)
                props.accept()
                window.location.reload();
            },
            declineCookies(props) {
                this.marketingCookieAllow = false
                this.analyticsCookieAllow = false
                this.$store.dispatch('saveMarketingConsentState', this.marketingCookieAllow)
                this.$store.dispatch('saveAnalyticsConsentState', this.analyticsCookieAllow)
                props.decline()
                window.location.reload();
            },
            openCookieModal(props) {
                this.cookieProps = props
                props.close()
                $('#cookieModal').modal()
            },
            saveSelectedCookies() {
                this.$store.dispatch('saveMarketingConsentState', this.marketingCookieAllow)
                this.$store.dispatch('saveAnalyticsConsentState', this.analyticsCookieAllow)
                this.cookieProps.accept()
                $('#cookieModal').modal('hide')
                window.location.reload();
            },
            reloadPage() {
                this.cookieProps.open()
            }
        }
    }
</script>

<style scoped>
    .cookie-message {
        padding: 0.7rem;
        font-size: 0.8rem;
    }

    .cookie-button {
        border-style: none;
        background-color: #4092e5 !important;
        font-size: 0.9rem !important;
        transition: 0.2s;
    }

    .cookie-button:nth-child(1) {
        width: 100%;
    }

    .cookie-button:nth-child(2), .cookie-button:nth-child(3) {
        width: 49%;
    }

    .cookie-button.de {
        width: 100% !important;
    }

    .cookie-button:nth-child(3) {
        float: right;
    }

    .cookie-button:hover {
      background-color: #295d92 !important;
    }

    .save-button {
        border-style: solid;
        border-width: 1px;
        border-color: #4092e5;
    }

    .mt-footer-section, .mt-footer-section a {
        color: #fff;
    }

    .mt-footer-section .footer-item {
        line-height: 0.75;
    }

    .mt-footer-section .icon-link {
        margin: 0 5px 0 0;
    }

    .mt-phone-fixed {
        position: fixed;
        bottom: 15px;
        right: 15px;
        z-index: 100;
    }

    #mt-phone-fixed img {
      right: 10px;
    }
</style>